import { type ReactNode } from 'react';
import { Link } from 'react-router-dom';

interface IconButtonLinkProps {
    cssClasses?: string;
    icon: ReactNode;
    children?: ReactNode;
    count?: number;
    to: string;
    ariaLabel?: string;
}

const IconButtonLink = ({ cssClasses = "", icon, children = null, to, count = undefined, ariaLabel }: IconButtonLinkProps) => {
    const hasText = Boolean(children);

    return (
        <Link to={to} className={`btn btn--icon btn--icon-only ${cssClasses}`} aria-label={ariaLabel ?? (hasText ? undefined : 'Icon button')}>
            <span className="btn__icon" aria-hidden={!!children}>
                {icon}
            </span>

            {children && <span className="btn__txt">{children}</span>}

            {typeof count === 'number' && count > 0 && (
                <span className="btn__count">{count}</span>
            )}
        </Link>
    );
};

export default IconButtonLink;
